//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../services/api";



//--------------- FUNÇÃO ASSÍNCRONA LOAD USERS SERVICE ---------------//
// Responsável por requisitar à API os Usuários existentes
export default async function loadProfileService() {
    try {
        const response = await api.get("/auth/profile");
        return response;
    } catch (err) {
        console.error("Erro ao buscar perfil");
        return null;
    }
}